function ConditionalWrapper({ condition, wrapper, children }) {
    var _a;
    return (condition ? (_a = wrapper(children)) !== null && _a !== void 0 ? _a : null : children);
}
ConditionalWrapper.displayName = 'ConditionalWrapper';
ConditionalWrapper.toString = () => `.vulcanui-conditional-wrapper`;
export default ConditionalWrapper;
//# sourceMappingURL=conditional-wrapper.js.map